import { Employee } from 'modules/core/hooks/useCurrentSession'

import { Expensable } from 'modules/expenses/types/Expensable'

type EmployeeFormValues = {
  employeeId: number
  employeeLegalEntity?: Omit<Employee['legalEntity'], 'country'> | null
}

export const getEmployeeDefaultValues = (
  employee: Employee,
  expensable?: Expensable
): EmployeeFormValues => {
  return {
    employeeId: expensable?.owner?.id || employee.id,
    employeeLegalEntity: expensable?.owner?.legalEntity || employee.legalEntity,
  }
}
